import React from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export type ToastType = 'success' | 'error' | 'warn';

type ToastProps = {
  message: string;
  type?: ToastType;
  visible: boolean;
};

function Toast({ message, type = 'success', visible }: ToastProps) {
  const severity = type === 'warn' ? 'warning' : type;

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className="material-toast"
      open={visible}
    >
      <Alert elevation={6} role="status" severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Toast;
